// src/common/hooks/useOrdersPolling.ts
import { useSelector } from "react-redux";
import { selectIsOnline } from "../../store/slices/networkSlice";
import { selectCurrentUser } from "../../store/slices/currentUserSlice";
import { selectIsExecutor } from "../../store/slices/executorSlice";
import { selectOrders } from "../../store/slices/orderSlice";
import { reloadUserData } from "../utils/functions/reloadUserData";
import useInterval from "@use-it/interval";

export const useOrdersPolling = () => {
  const isOnline = useSelector(selectIsOnline);
  const currentUser = useSelector(selectCurrentUser);
  const isExecutor = useSelector(selectIsExecutor);
  const orders = useSelector(selectOrders);

  const interval = isExecutor ? 5 * 60 * 1000 : 15 * 60 * 1000;

  useInterval(() => {
    if (isOnline && currentUser && orders.length > 0) {
      reloadUserData();
    }
  }, interval);
};
